// extracted by mini-css-extract-plugin
export default {"ConnectButton":"ConnectButton_d6ZnF","black":"black_p4stQ","mint":"mint_TeiRv","connect":"connect_gD_4g","connected":"connected_wJs8P","noHeader":"noHeader_OFbeG"};